import { Pipe, PipeTransform } from '@angular/core';

import { TypeConverter } from '@personal-area/global/common';

@Pipe({
  name: 'money',
  standalone: true,
})
export class MoneyPipe implements PipeTransform {

  transform(value: number | string, decimals = 2): string {
    const val = +value;
    if (isNaN(val)) {
      return <string>value;
    }

    return TypeConverter.deprecatedNumberToMoney(val, decimals);
  }

}
